module.exports = __webpack_public_path__ + "img/whats-new-7_en.d203922.jpg";